import { message } from 'antd';

// 오류 로깅
export const logGameError = (error, context = {}) => {
    const errorLog = {
        timestamp: new Date().toISOString(),
        error: {
            message: error.message || error.message || 'Unknown error',
            stack: error.stack,
            name: error.name || error.type
        },
        context,
        userAgent: navigator.userAgent,
        url: window.location.href
    };
    
    console.error('Game Error Log:', errorLog);
    
    // 실제 운영환경에서는 오류 로깅 서비스로 전송
    if (process.env.NODE_ENV === 'production') {
        // 예: Sentry, LogRocket 등으로 전송
        // sendErrorToLoggingService(errorLog);
    }
};

// 게임 오류 타입별 처리
export const handleGameError = (errorData) => {
    const { type, message: errorMessage, action_type, current_phase } = errorData;
    
    // 한 번만 로깅
    logGameError(errorData, { errorType: 'game_error' });
    
    switch (type) {
        case 'start_game_error':
            if (errorMessage.includes('최소')) {
                message.error('최소 3명 이상의 플레이어가 필요합니다.');
            } else if (errorMessage.includes('방장')) {
                message.error('방장만 게임을 시작할 수 있습니다.');
            } else {
                message.error(`게임 시작 실패: ${errorMessage}`);
            }
            break;
            
        case 'validation_error':
            switch (action_type) {
                case 'submit_description':
                    if (current_phase !== 'description') {
                        message.warning(`현재는 ${getPhaseKoreanName(current_phase)} 단계입니다.`);
                    } else {
                        message.warning('아직 설명할 차례가 아닙니다.');
                    }
                    break;
                case 'submit_vote':
                    if (current_phase !== 'vote') {
                        message.warning(`현재는 ${getPhaseKoreanName(current_phase)} 단계입니다.`);
                    } else {
                        message.warning('이미 투표하셨거나 투표할 수 없습니다.');
                    }
                    break;
                case 'submit_last_chance':
                    message.warning('라이어의 마지막 기회 단계가 아니거나 라이어가 아닙니다.');
                    break;
                default:
                    message.warning(errorMessage);
            }
            break;
            
        case 'game_state_error':
            message.error('게임 상태를 찾을 수 없습니다. 게임을 다시 시작해주세요.');
            break;
            
        case 'action_processing_error':
            message.error(`액션 처리 중 오류가 발생했습니다: ${errorMessage}`);
            break;
            
        case 'vote_start_error':
            message.error(`투표를 시작할 수 없습니다: ${errorMessage}`);
            break;
            
        case 'connection_error':
            message.error('서버 연결에 문제가 있습니다. 잠시 후 다시 시도해주세요.');
            break;
            
        default:
            message.error(`게임 오류: ${errorMessage}`);
    }
};

// 게임 단계 한국어 변환
const getPhaseKoreanName = (phase) => {
    const phaseMap = {
        'description': '설명',
        'discussion': '토론',
        'vote': '투표',
        'last_chance': '라이어 마지막 기회',
        'finished': '게임 종료'
    };
    return phaseMap[phase] || phase;
};

// 사용자 친화적 오류 메시지 생성
export const createUserFriendlyErrorMessage = (error) => {
    if (error.response?.data?.error) {
        return error.response.data.error;
    }
    
    if (error.message) {
        // 네트워크 오류
        if (error.message.includes('Network')) {
            return '네트워크 연결을 확인해주세요.';
        }
        // 타임아웃 오류
        if (error.message.includes('timeout')) {
            return '요청 시간이 초과되었습니다. 다시 시도해주세요.';
        }
        return error.message;
    }
    
    return '알 수 없는 오류가 발생했습니다.';
};

// 재시도 가능한 오류인지 확인
export const isRetryableError = (error) => {
    const retryableCodes = [408, 429, 500, 502, 503, 504];
    const statusCode = error.response?.status;
    
    return retryableCodes.includes(statusCode) || 
           error.message?.includes('timeout') ||
           error.message?.includes('Network');
};

